export default {
  forgot: {
    tentative: {
      1: 'You have 2 attempts left',
      2: 'This is your last attempt, your account will be blocked in the event of an error',
      3: 'Your account has just been locked, please contact CIEM',
    },
    userNotFound: 'User not found',
    secretQuestionNotFound: 'Secret question not found',
    confirmationChange: 'Password successfully changed',
    confirmationMailSent: 'Email sent',
    confirmationSMSSent: 'SMS sent',
    expire: {
      title: 'Link expired',
      text: 'This link has expired, please go to the forgot password section to re-request a password change.',
    },
  },
}
